const HOME_INIT_URL = '/home/init';
const FIND_CITY_URL = '/geo/city/data/find-for-select';

const API_HOME_NAME = 'apiHome';

export {
  HOME_INIT_URL,
  FIND_CITY_URL,

  API_HOME_NAME,
};
